import {Typography} from "../common/Typography";
import {Button} from "../common/Button";
import React, {useState} from "react";
import {useQuizMeta} from "../quiz/useQuizMeta";
import {useAppTranslation} from "../app/appContext";
import {useQuestions} from "../question/useQuestions";
import {createUseStyles} from "react-jss";
import {useView} from "../quiz/useView";

const useStyles = createUseStyles((theme) => ({
    title: {
        textAlign: "center",
    },
    score: {
        textAlign: "center",
    },
    buttons: {
        marginTop: "50px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        "& button": {
            margin: "0 12px",
        },
    },
    button: {
        backgroundColor: theme.colors.black,
        border: `2px solid ${theme.colors.white} !important`,
        "& label": {
            color: theme.colors.white,
        },
        "&:hover": {
            backgroundColor: theme.colors.white,
            border: `2px solid ${theme.colors.black} !important`,
            "& label": {
                color: theme.colors.black,
            },
        },
    },
    feedback: {
        marginTop: "16px",
        textAlign: "center",
        color: "#4ade80",
        fontWeight: "bold",
    },
}));

export const ResultHeader = ({score}) => {
    const {title} = useQuizMeta();
    const classes = useStyles();
    const t = useAppTranslation();
    const questions = useQuestions();
    const {resetQuiz} = useView();
    const [feedbackMessage, setFeedbackMessage] = useState(null);

    const handleShareResult = async () => {
        const totalQuestions = questions?.length || 0;
        const shareText = `Jeg fikk ${score} av ${totalQuestions} riktige i quizen «${title}»!`;
        const sharePayload = {
            title: title,
            text: shareText,
            url: typeof window !== "undefined" ? window.location?.href : ""
        };

        if (navigator?.share) {
            try {
                await navigator.share(sharePayload);
            } catch (err) {
                if (err?.name !== "AbortError") {
                    console.warn("Share failed:", err);
                }
            }
        } else if (navigator?.clipboard?.writeText) {
            try {
                await navigator.clipboard.writeText(shareText);
                setFeedbackMessage(t("shareCopied", "Kopiert til utklippstavle!"));
                setTimeout(() => {
                    setFeedbackMessage(null);
                }, 3000);
            } catch (err) {
                console.warn("Clipboard copy failed:", err);
            }
        }
    };

    return (
        <>
            <Typography tag="h1" size="xl5" bold className={classes.title}>
                {title}
            </Typography>
            <Typography tag="h2" size="xl7" bold className={classes.score}>
                {score} {t("of", "av")} {questions.length}{" "}
                {t("correctAnswers", "riktige svar")}
            </Typography>
            <div className={classes.buttons}>
                <Button
                    label={t("resetButton", "Ta Quizen igjen")}
                    onClick={resetQuiz}
                    outline
                    className={classes.button}
                />
                <Button
                    label={t("shareButton", "Del resultatet")}
                    onClick={handleShareResult}
                    outline
                    className={classes.button}
                />
            </div>
            {feedbackMessage && (
                <div
                    role="status"
                    aria-live="polite"
                    data-testid="share-feedback"
                    className={classes.feedback}
                >
                    {feedbackMessage}
                </div>
            )}
        </>
    );
};
